import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { media } from "../styles/breakpoints";
import { font } from "../styles/typography";

const HeaderStyle = styled.header`
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 12px 0;
  background: var(--spark-color-surface);
  box-shadow: 0 2px 8px var(--spark-color-shadow);
  position: sticky;
  top: 0;
  z-index: 100;
`;

const LogoLink = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    color: var(--spark-color-brand);
  }
`;

const LogoImg = styled.img`
  height: 40px;
  width: auto;
  display: block;
  flex-shrink: 0;
`;

const LogoText = styled.span`
  font-weight: 700;
  ${font('xxl')}
  color: var(--spark-color-text);

  ${media.tablet`
    display: none;
  `}
`;

const EnvBadge = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: var(--spark-color-info-text);
  opacity: 0.25;
  pointer-events: none;
  user-select: none;
  white-space: nowrap;
  box-shadow: 0 0 31px 14px var(--spark-color-shadow);
  padding: 0 5px;
  border-radius: 10px;
  background-color: var(--spark-color-info-surface);
`;

const HeaderInner = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  margin: 0 auto;
  padding: 0 32px;
  width: 100%;

  ${media.laptopSm`
    gap: 16px;
    padding: 0 16px;
  `}
`;

const StyledLink = styled(NavLink)`
  color: var(--spark-color-text-secondary);
  text-decoration: none;
  ${font('lg')}
  transition: color 0.15s;

  &:hover {
    color: var(--spark-color-brand);
  }

  &.active {
    color: var(--spark-color-brand);
  }
`;

const NavLinks = styled.nav`
  display: flex;
  align-items: center;
  gap: 32px;

  ${media.laptopSm`
    gap: 16px;
  `}

  ${media.tablet`
    display: none;
  `}
`;

const BurgerButton = styled.button`
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  flex-shrink: 0;

  span {
    display: block;
    width: 20px;
    height: 2px;
    background: var(--spark-color-text);
    border-radius: 1px;
    transition: transform 0.15s ease, opacity 0.15s ease;
  }

  ${media.tablet`
    display: flex;
  `}
`;

const MobileNavPanel = styled.nav`
  display: ${(p) => (p.$open ? 'flex' : 'none')};
  flex-direction: column;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--spark-color-surface);
  box-shadow: 0 4px 12px var(--spark-color-shadow-strong);
  padding: 8px 0;
  z-index: 10;
`;

const MobileNavLink = styled(NavLink)`
  padding: 14px 24px;
  color: var(--spark-color-text);
  text-decoration: none;
  ${font('lg')}

  &:hover {
    background: var(--spark-color-surface-muted);
  }

  &.active {
    color: var(--spark-color-brand);
    background: var(--spark-color-action-hover-surface);
  }
`;

export {
  HeaderStyle,
  HeaderInner,
  LogoLink,
  LogoImg,
  LogoText,
  StyledLink,
  EnvBadge,
  NavLinks,
  BurgerButton,
  MobileNavPanel,
  MobileNavLink,
};
